import React from "react";
import LegalDocument from "../../components/LegalDocument";
import AccessibilityMarkdown from "../../content/markdown/legal/AccessibilityPolicy.md";

const SectionAccessibilityPolicy = () => <LegalDocument markdownPath={AccessibilityMarkdown} />;

export default SectionAccessibilityPolicy;
